"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var FieldDetailsQueryGql_1 = require("../../queries/FieldDetailsQueryGql");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var renderQueryResult_1 = require("../renderQueryResult");
var FieldInlineDescriptionEditor_1 = require("./FieldInlineDescriptionEditor");
var FieldPropertyComponents_1 = require("./FieldPropertyComponents");
var dialogWidth = 500;
var FieldDetailsPane = data_catalog_shared_1.divWithStyle('FieldDetailsPane', __assign(__assign({}, data_catalog_shared_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.FieldDetailsFieldName = data_catalog_shared_1.divWithStyle('FieldDetailsFieldName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
var FieldDetailsTypeRow = data_catalog_shared_1.divWithStyle('FieldDetailsTypeRow', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
var FieldDetailsProperties = data_catalog_shared_1.divWithStyle('FieldDetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
var FieldDetailsDialog = /** @class */ (function (_super) {
    __extends(FieldDetailsDialog, _super);
    function FieldDetailsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFieldDetails = function (data) {
            var field = data.fields && data.fields[0];
            if (!field) {
                return null;
            }
            var fieldIcon = FieldFunctions_1.iconForField(field);
            return (React.createElement(widgets_1.DialogWidget, { testId: 'field-details', title: Localize_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: _this.props.onClose, handleGlassClick: _this.props.onClose },
                React.createElement(FieldDetailsPane, null,
                    React.createElement(exports.FieldDetailsFieldName, null, field.name),
                    React.createElement(FieldDetailsTypeRow, null,
                        React.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }),
                        fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : null),
                    React.createElement(FieldDetailsProperties, null,
                        _this.renderDescriptions(field, _this.props.canEditDescription, _this.props.datasourceLuid),
                        React.createElement(FieldPropertyComponents_1.FieldPropertyFolderName, { folderName: field.folderName }),
                        React.createElement(FieldPropertyComponents_1.FieldPropertyIsHidden, { isHidden: field.isHidden }),
                        _this.renderTypeSpecificFieldDetails(field),
                        _this.renderRelatedItems(field)))));
        };
        return _this;
    }
    FieldDetailsDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: FieldDetailsQueryGql_1.FieldDetailsQueryGql, variables: { fieldId: this.props.fieldId } }, function (result) { return renderQueryResult_1.renderQueryResult(result, { renderData: _this.renderFieldDetails }); }));
    };
    FieldDetailsDialog.prototype.renderDescriptions = function (field, canEditDescription, datasourceLuid) {
        if (field.__typename === 'DatasourceField' && field.remoteField) { // workbook field descriptions cannot currently be edited
            return (React.createElement(React.Fragment, null,
                React.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: Localize_1.Messages.DescriptionWorkbook, description: field.description }),
                React.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: Localize_1.Messages.DescriptionDataSource, description: field.remoteField.description })));
        }
        else {
            return (React.createElement(FieldInlineDescriptionEditor_1.FieldInlineDescriptionEditor, { canEditDescription: canEditDescription, description: field.description || '', datasourceLuid: datasourceLuid || '', fullyQualifiedFieldName: field.fullyQualifiedName || '', fieldType: field.__typename, afterDescriptionChange: this.props.afterDescriptionChange }));
        }
    };
    FieldDetailsDialog.prototype.renderTypeSpecificFieldDetails = function (field) {
        if (field.__typename !== 'DatasourceField') {
            return this.renderTypeSpecificNonDatasourceFieldDetails(field);
        }
        else if (field.remoteField) {
            return this.renderTypeSpecificNonDatasourceFieldDetails(field.remoteField);
        }
        else {
            return null;
        }
    };
    FieldDetailsDialog.prototype.renderRelatedItems = function (field) {
        if (field.__typename === 'ColumnField') {
            var count = field.columnsConnection ? field.columnsConnection.totalCount : null;
            return React.createElement(FieldPropertyComponents_1.ColumnsReferencingField, { fieldId: field.id, rowCount: count });
        }
        else if (field.__typename === 'DatasourceField') {
            var remoteField = field.remoteField;
            if (remoteField) {
                var datasource = remoteField.datasource;
                var datasourceVizPortalUrlId = datasource && datasource.__typename === 'PublishedDatasource' ? datasource.vizportalUrlId : null;
                var datasourceName = datasource ? datasource.name : null;
                return (React.createElement(FieldPropertyComponents_1.ConnectedField, { fieldId: remoteField.id, fieldName: remoteField.name, datasourceVizPortalUrlId: datasourceVizPortalUrlId, datasourceName: datasourceName }));
            }
            else {
                return null;
            }
        }
        else {
            var count = field.fieldsConnection ? field.fieldsConnection.totalCount : null;
            return React.createElement(FieldPropertyComponents_1.FieldsReferencedByField, { fieldId: field.id, rowCount: count });
        }
    };
    FieldDetailsDialog.prototype.renderTypeSpecificNonDatasourceFieldDetails = function (field) {
        switch (field.__typename) {
            case 'BinField':
                return (React.createElement(React.Fragment, null,
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyFormula, { formula: field.formula, fields: field.fields, parameters: field.parameters, makeFieldUrl: this.props.makeFieldUrl }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyBinSize, { binSize: field.binSize })));
            case 'CalculatedField':
                return (React.createElement(React.Fragment, null,
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyAggregation, { aggregation: field.aggregation }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyAggregationParam, { aggregationParam: field.aggregationParam }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDefaultFormat, { defaultFormat: field.defaultFormat }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertySemanticRole, { semanticRole: field.semanticRole }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyFormula, { formula: field.formula, fields: field.fields, parameters: field.parameters, makeFieldUrl: this.props.makeFieldUrl }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyHasUserReference, { hasUserReference: field.hasUserReference }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyIsAutoGenerated, { isAutoGenerated: field.isAutoGenerated })));
            case 'ColumnField':
                return (React.createElement(React.Fragment, null,
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyAggregation, { aggregation: field.aggregation }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyAggregationParam, { aggregationParam: field.aggregationParam }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDefaultFormat, { defaultFormat: field.defaultFormat }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertySemanticRole, { semanticRole: field.semanticRole })));
            case 'CombinedField':
                return null;
            case 'CombinedSetField':
                return (React.createElement(React.Fragment, null,
                    React.createElement(FieldPropertyComponents_1.FieldPropertyCombinationType, { combinationType: field.combinationType }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDelimiter, { delimiter: field.delimiter })));
            // We don't expect datasource fields here;
            // they're handled in renderTypeSpecificFieldDetails.
            case 'DatasourceField':
                return null;
            case 'GroupField':
                return (React.createElement(React.Fragment, null,
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                    React.createElement(FieldPropertyComponents_1.FieldPropertyHasOther, { hasOther: field.hasOther })));
            case 'HierarchyField':
                return null;
            case 'SetField':
                return null;
            default:
                data_structures_1.assertNever(field);
                return null;
        }
    };
    return FieldDetailsDialog;
}(React.Component));
exports.FieldDetailsDialog = FieldDetailsDialog;
//# sourceMappingURL=FieldDetailsDialog.js.map